import React from 'react';
import ReactDOM from 'react-dom';
import App from './js/components/App';

require('./less/style.less');

ReactDOM.render(<App />, document.getElementById('root'));
